document.addEventListener('DOMContentLoaded', function () {
    const regInput = document.getElementById('cta-input');
    const ctaLink = document.getElementById('cta-link');

    if (regInput && ctaLink) {
        regInput.addEventListener('input', function () {
            const inputValue = this.value;
            localStorage.setItem('regnr-vehicle', inputValue);
            regInput.classList.remove('input-error');
        });

        ctaLink.addEventListener('click', function (event) {
            if (!regInput.value.trim()) {
                event.preventDefault();
                regInput.classList.add('input-error');
            }
        });
    }

    //Author Tabs
    const tabs = document.querySelectorAll('.author-info__tab');
    const tabContents = document.querySelectorAll('.tab-content');
  
    if (tabs.length > 0 && tabContents.length > 0) {
        tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            tabs.forEach(function(t) {
            t.classList.remove('active');
            });
            tab.classList.add('active');
    
            tabContents.forEach(function(content) {
            content.style.display = 'none';
            });
            const target = this.getAttribute('data-tab');
            const targetContent = document.getElementById('tab-content-' + target);
            if (targetContent) {
            targetContent.style.display = 'block';
            }
        });
        });
    }
});